export const getPages = (
  activePage: number,
  numberPages: number,
  visibleNear = 2
) => {
  const pages: string[] = [];

  // определение крайней левой страницы от активной
  let startPage = activePage - visibleNear;
  if (startPage <= 0) {
    startPage = 1;
  } else if (activePage + visibleNear > numberPages && startPage > 2) {
    startPage -= activePage - numberPages + visibleNear;
  }

  // краевые случаи в начале пагинации
  if (startPage > 2) {
    pages.push('1', '...');
  } else if (startPage === 2) {
    pages.push('1');
  }

  for (let page = startPage; page < visibleNear * 2 + 1 + startPage; page++) {
    if (page > numberPages) break;

    pages.push(String(page));
  }

  // краевые случаи в конце пагинации
  const lastPage = Number(pages.at(-1));
  if (lastPage < numberPages - 1) {
    pages.push('...', String(numberPages));
  } else if (lastPage === numberPages - 1) {
    pages.push(String(numberPages));
  }

  return pages;
};

export const getActivePage = (startPage: number, numberPages: number) => {
  if (startPage < 0 || startPage > numberPages) {
    return 1;
  }

  return startPage;
};
